import {
  Leasing,
  LeasingEditFormValues,
  LeasingRow,
} from "./types";


/*---------------------------------------------------------------------------------------
  CALCULATION LEASING 
-----------------------------------------------------------------------------------------*/

export const transformLeasing = (res: any): Leasing => {
  return {
    id: res.id,
    leasingTypeId: res.leasingType.id,
    leasingTypeName: res.leasingType.name,
    name: res.name,
    interestRate: res.interestRate,
  };
};

/*---------------------------------------------------------------------------------------
  CALCULATION LEASING SEARCH
-----------------------------------------------------------------------------------------*/

export const transformLeasingRow = (
  res: any
): LeasingRow => {
  return {
    id: res.id,
    name: res.name,
    leasingTypeName: res.leasingType.name,
    interestRate: res.interestRate,
  };
};

/*---------------------------------------------------------------------------------------
    CALCULATION LEASING CREATE
  -----------------------------------------------------------------------------------------*/

export const transformLeasingOnCreate = (
  formValues: LeasingEditFormValues
): any => ({
  leasingTypeId: formValues.leasingTypeId,
  name: formValues.name,
  interestRate: formValues.interestRate,
});

/*---------------------------------------------------------------------------------------
  CALCULATION LEASING EDIT
-----------------------------------------------------------------------------------------*/

export const transformLeasingOnUpdate = (
  formValues: LeasingEditFormValues
): any => ({
  id: formValues.id,
  leasingTypeId: formValues.leasingTypeId,
  name: formValues.name,
  interestRate: formValues.interestRate,
});

